@if (!maintenanceMode) {
<ng-container class="mat-app-background">
  @if (!routingReady) {
  <app-logo-loader id="logo-loader" [logo]="logoImageSource"></app-logo-loader>
  }
  <router-outlet></router-outlet>
  @if (!onCheckingNotAvailableRouters()) {
  <app-footer></app-footer>
  }
</ng-container>
}
